import styled, { css } from 'styled-components';
import Button from '../../BuildingBlocks/Button';

export const StyledButton = styled(Button)`
  vertical-align: middle;

  > * {
    margin: 0 0 0 5px;
    line-height: 0;
    vertical-align: middle;
  }
`;

export const StyledSingleDateSelect = styled.div`
  ${props =>
    !props.stack &&
    css`
      > * {
        margin-right: 3.33%;
        display: inline-block;
        vertical-align: middle;
      }

      > *:last-child {
        margin-right: 0;
      }
    `};
`;
